// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayPopoverSkeleton-moduleCalendarGridDayPopoverSkeleton__V5M_w";
var _2 = "CalendarGridDayPopoverSkeleton-modulerow__la_Bs Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "CalendarGridDayPopoverSkeleton", _2 as "row" }
